import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcHumanColor = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 34,
	height: 34,
	viewBox: "0 0 34 34",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M21.8571 10.9314C21.8571 13.6139 19.6825 15.7885 16.9999 15.7885C14.3174 15.7885 12.1428 13.6139 12.1428 10.9314C12.1428 8.24884 14.3174 6.07422 16.9999 6.07422C19.6825 6.07422 21.8571 8.24884 21.8571 10.9314Z",
		fill: "#6C9CFA"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M7.28564 20.6456C7.28564 18.6338 8.91661 17.0028 10.9285 17.0028H23.0714C25.0833 17.0028 26.7142 18.6338 26.7142 20.6456V26.7171C26.7142 27.3877 26.1706 27.9314 25.4999 27.9314H8.49993C7.8293 27.9314 7.28564 27.3877 7.28564 26.7171V20.6456Z",
		fill: "#A7C4FC"
	})]
});
export default SvgIcHumanColor;
